
export class IdentityProviderTableContext {

  public readonly canExpandRows: boolean;
  public readonly showTenantSearch: boolean;
  public readonly isTenantTable: boolean;

  constructor(
    public readonly tenantId: number,
    public readonly featureEnabled: boolean,
    public readonly accessControlEnabled: boolean,
    public readonly isSuperAdmin: boolean,
    public readonly title: string,
    public readonly tableType: 'tenant' | 'system',
    public readonly actionLabel?: string,
    public readonly action?: () => void,
    public readonly actionLink?: string[],
  ) {
    this.isTenantTable = this.tableType === 'tenant';
    this.canExpandRows = this.featureEnabled && this.accessControlEnabled && this.isTenantTable;
    this.showTenantSearch = this.isTenantTable && this.isSuperAdmin;
  }

  public static create(context: Partial<IdentityProviderTableContext>): IdentityProviderTableContext {
    return new IdentityProviderTableContext(
      context.tenantId,
      context.featureEnabled,
      context.accessControlEnabled,
      context.isSuperAdmin,
      context.title,
      context.tableType,
      context.actionLabel,
      context.action,
      context.actionLink
    );
  }
}
